import ActiveIndicator from "@app/components/active-indicator.tsx";
import DeleteButton from "@app/components/delete-button.tsx";
import { AssignmentDetailsModel } from "@app/data/engine.ts";
import { formatUsd } from "@app/helpers/money-helper.ts";
import { formatDate } from "@app/helpers/time-helper.ts";
import EditIcon from "@mui/icons-material/Edit";
import { Box } from "@mui/material";
import { createColumnHelper, IconButton } from "bi-lib";

interface Props {
    onEdit: (id: number) => void;
    onDelete: (id: number) => void;
    rowCount: number;
}

const columnHelper = createColumnHelper<AssignmentDetailsModel>();
export const assignmentExpenseRateDetailsTableDefinition = ({ onEdit, onDelete, rowCount }: Props) => [
    columnHelper.display({
        id: "actions",
        header: "Actions",
        cell: (item) => (
            <Box display={"flex"}>
                <IconButton tooltip={"Edit"} onClick={() => onEdit(item.row.original.assignDetailId!)}>
                    <EditIcon />
                </IconButton>
                <DeleteButton onDelete={() => onDelete(item.row.original.assignDetailId!)} />
            </Box>
        ),
        footer: () => `${rowCount} Rows`,
    }),
    columnHelper.accessor((x) => x.workPackageCode, { id: "workPackageCode", header: "WP Code" }),
    columnHelper.accessor((x) => x.effectiveDate, {
        id: "effectiveDate",
        header: "Effective Date",
        cell: (item) => formatDate(item.getValue()),
    }),
    columnHelper.group({
        id: "billable",
        header: "Billable",
        columns: [
            columnHelper.accessor((x) => x.billableTime, {
                id: "billableTime",
                header: "Time",
                cell: (item) => <ActiveIndicator isActive={item.getValue()} />,
            }),
            columnHelper.accessor((x) => x.billableTravelExpense, {
                id: "billableTravelExpense",
                header: "Travel Expenses",
                cell: (item) => <ActiveIndicator isActive={item.getValue()} />,
            }),
            columnHelper.accessor((x) => x.billableOtherIndividualExpense, {
                id: "billableOtherIndividualExpense",
                header: "Other Expenses",
                cell: (item) => <ActiveIndicator isActive={item.getValue()} />,
            }),
            columnHelper.accessor((x) => x.billableOfficeExpense, {
                id: "billableOfficeExpense",
                header: "Office Expenses",
                cell: (item) => <ActiveIndicator isActive={item.getValue()} />,
            }),
        ],
    }),
    columnHelper.group({
        id: "invoice",
        header: "Invoice",
        columns: [
            columnHelper.accessor((x) => x.invoiceVisibleTime, {
                id: "invoiceVisibleTime",
                header: "Time",
                cell: (item) => <ActiveIndicator isActive={item.getValue()} />,
            }),
            columnHelper.accessor((x) => x.invoiceVisibleTravelExpense, {
                id: "invoiceVisibleTravelExpense",
                header: "Travel Expenses",
                cell: (item) => <ActiveIndicator isActive={item.getValue()} />,
            }),
            columnHelper.accessor((x) => x.invoiceVisibleOtherIndividualExpense, {
                id: "invoiceVisibleOtherIndividualExpense",
                header: "Other Expenses",
                cell: (item) => <ActiveIndicator isActive={item.getValue()} />,
            }),
            columnHelper.accessor((x) => x.invoiceVisibleOfficeExpense, {
                id: "invoiceVisibleOfficeExpense",
                header: "Office Expenses",
                cell: (item) => <ActiveIndicator isActive={item.getValue()} />,
            }),
        ],
    }),
    columnHelper.group({
        id: "default",
        header: "Default",
        columns: [
            columnHelper.accessor((x) => x.defaultBillingRate, {
                id: "defaultBillingRate",
                header: "Billing",
                cell: (item) => formatUsd(item.getValue()),
                alignment: "right",
            }),
            columnHelper.accessor((x) => x.defaultCostRate, {
                id: "defaultCostRate",
                header: "Cost",
                cell: (item) => formatUsd(item.getValue()),
                alignment: "right",
            }),
            columnHelper.accessor((x) => x.defaultInternalRate, {
                id: "defaultInternalRate",
                header: "Internal",
                cell: (item) => formatUsd(item.getValue()),
                alignment: "right",
            }),
        ],
    }),
];
